import React, { useState } from 'react';
import { 
  Info
} from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  label?: string;
  label_separate?: boolean;
  title?: string;
  children?: React.ReactNode;
  onClick?: () => void;
}

export default function InfoButton({ 
  label = "",
  label_separate = false,
  title = "Information",
  children,
  onClick
}: Props) {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    if (children) {
      setOpen(true);
    } else if (onClick) {
      onClick();
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const button = label === "" ? (
    <Info 
      className="clickable"
      style={{ fontSize: "12px" }}
      onClick={handleClick}
    />
  ) : (
    <span
      className="clickable"
      style={{ fontSize: "12px" }}
      onClick={handleClick}>
      <Info/>&nbsp;{label}
    </span>
  );

  return (
    <>
      {button}
      <Dialog 
        open={open} 
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {title}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {children}
        </DialogContent>
      </Dialog>
    </>
  );
}